import { createApi } from '@reduxjs/toolkit/query/react';
import baseQueryWithErrorHandling from './baseQuery';

// Define the response type based on the YAML schema
export interface DtcTitleResponse {
    spn_title: string;
}

// Define the request parameters type
export interface DtcTitleParams {
    asset_id: string;
    spn: any;
    ecu_short_name?: string;
    can_address?: any;
}

// Create a custom base query that handles mock data
const customBaseQuery = async (args: any, api: any, extraOptions: any) => {
    const baseQuery = baseQueryWithErrorHandling({ baseUrl: 'https://api.vehicleuptime.rio.cloud' });
    return baseQuery(args, api, extraOptions);
};

// Create the API service
export const dtcApi = createApi({
    reducerPath: 'dtcApi',
    baseQuery: customBaseQuery,
    endpoints: builder => ({
        getDtcTitle: builder.query<DtcTitleResponse, DtcTitleParams>({
            query: params => {
                return {
                    url: '/dtc-title',
                    method: 'GET',
                    params: {
                        asset_id: params.asset_id,
                        spn: params.spn !== undefined ? params.spn.toString() : undefined,
                        ecu_short_name: params.ecu_short_name,
                        can_address: params.can_address !== undefined ? params.can_address.toString() : undefined,
                    },
                };
            },
        }),
    }),
});

export const { useGetDtcTitleQuery, useLazyGetDtcTitleQuery } = dtcApi;
